/**
 * @generated SignedSource<<172264b27696485de310f851e4292bfb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgAdminTeamsSelector_teams$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"OrgTeamListItem_team">;
  readonly " $fragmentType": "OrgAdminTeamsSelector_teams";
}>;
export type OrgAdminTeamsSelector_teams$key = ReadonlyArray<{
  readonly " $data"?: OrgAdminTeamsSelector_teams$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrgAdminTeamsSelector_teams">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "OrgAdminTeamsSelector_teams",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrgTeamListItem_team"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "f6961165bf80735e9b0a7035ff3ad2f9";

export default node;
